import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IDistributorsRequest,
  IDistributorListResponse,
  IDistributorResponse,
  ICommonDistributor,
  IUpdateDistributorRequest,
  ISearchDistributorResponse,
} from "./distributors.interfaces";
import {
  addDistributorService,
  deleteDistributorService,
  getDistributorService,
  getDistributorsService,
  searchDistributorService,
  updateDistributorService,
} from "./distributors.services";

export const getDistributors = createAsyncThunk<
  IDistributorListResponse,
  IDistributorsRequest,
  { rejectValue: any }
>("distributors/getDistributors", async (payload, { rejectWithValue }) => {
  try {
    const { page, limit, sort, order, search } = payload ?? {};

    const data = await getDistributorsService(
      page ?? 0,
      limit ?? 10,
      sort ?? "inserted",
      order ?? "desc",
      search ?? ""
    );

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message);
  }
});

export const getDistributor = createAsyncThunk<
  IDistributorResponse,
  string,
  { rejectValue: any }
>("distributors/getDistributor", async (id, { rejectWithValue }) => {
  try {
    const data = await getDistributorService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message);
  }
});

export const addDistributor = createAsyncThunk<
  IDistributorResponse,
  ICommonDistributor,
  { rejectValue: any }
>("distributors/addDistributor", async (distributor, { rejectWithValue }) => {
  try {
    const data = await addDistributorService(distributor);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message);
  }
});

export const updateDistributor = createAsyncThunk<
  IDistributorResponse,
  IUpdateDistributorRequest,
  { rejectValue: any }
>(
  "distributors/updateDistributor",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const data = await updateDistributorService(id, payload);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const deleteDistributor = createAsyncThunk<
  IDistributorResponse,
  string,
  { rejectValue: any }
>("distributors/deleteDistributor", async (id, { rejectWithValue }) => {
  try {
    const data = await deleteDistributorService(id);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message);
  }
});

export const searchDistributor = createAsyncThunk<
  ISearchDistributorResponse[],
  string,
  { rejectValue: any }
>("distributors/searchDistributor", async (search, { rejectWithValue }) => {
  try {
    const data = await searchDistributorService(search);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message);
  }
});
